
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 0c6.075 0 11 2.686 11 6v4c0 3.314-4.925 6-11 6C5.033 16 .176 13.409.005 10.177L0 10V6c0-3.314 4.925-6 11-6zm0 12c-3.72 0-7.01-1.007-9-2.55V10c0 1.882 3.883 4 9 4 5.01 0 8.838-2.03 8.995-3.882L20 10l.001-.55C18.011 10.992 14.721 12 11 12zm0-10C5.883 2 2 4.118 2 6c0 1.882 3.883 4 9 4s9-2.118 9-4c0-1.882-3.883-4-9-4z","fill":"#FAAD14"}})])
          )
        }
      }
    